var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 5.83366C0.447715 5.83366 0 6.28137 0 6.83366C0 7.38594 0.447715 7.83366 1 7.83366V5.83366ZM21 7.83366C21.5523 7.83366 22 7.38594 22 6.83366C22 6.28137 21.5523 5.83366 21 5.83366V7.83366ZM1 11.6672C0.447715 11.6672 0 12.1149 0 12.6672C0 13.2194 0.447715 13.6672 1 13.6672V11.6672ZM21 13.6672C21.5523 13.6672 22 13.2194 22 12.6672C22 12.1149 21.5523 11.6672 21 11.6672V13.6672ZM1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2V0ZM21 2C21.5523 2 22 1.55228 22 1C22 0.447715 21.5523 0 21 0V2ZM1 7.83366H21V5.83366H1V7.83366ZM1 13.6672H21V11.6672H1V13.6672ZM1 2H21V0H1V2Z","fill":"#16384E"}));
}

MenuInline.defaultProps = {"width":"22","height":"14","viewBox":"0 0 22 14","fill":"none"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
